<section style="height: 90%">
  <h1>Hola, {{ displayName }}</h1>

  <p>Tabla de datos de perfil:</p>
  <table class="table table-striped">
    <thead>
      <tr>
        <th>Campo</th>
        <th>Valor</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let field of profileFields">
        <td>{{ field.label }}</td>
        <td>{{ field.value }}</td>
      </tr>
    </tbody>
  </table>
</section>
